<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-icon>mdi-trackpad</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex">
            <span class="font-weight-bold">{{ microsite.name }}</span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
export default {
  props: {
    microsite: {
      type: Object,
      required: true
    }
  }
};
</script>
